export const RUSSIAN_BANKS = [
  { name: 'Sberbank', domain: 'sberbank.ru', color: '#21A038' },
  { name: 'T-Bank', domain: 'tbank.ru', color: '#FFDD2D' },
  { name: 'VTB', domain: 'vtb.ru', color: '#0A2896' },
  { name: 'Alfa-Bank', domain: 'alfabank.ru', color: '#EF3124' },
  { name: 'Gazprombank', domain: 'gazprombank.ru', color: '#1A4A8C' },
  { name: 'Raiffeisen', domain: 'raiffeisen.ru', color: '#FFED00' },
];

export const bankLogo = (domain) => `https://logo.clearbit.com/${domain}`;

export function detectCardBrand(number) {
  const n = (number || '').replace(/[\s-]/g, '');
  if (!/^\d{2,}$/.test(n)) return null;
  const p4 = parseInt(n.slice(0, 4), 10);
  if (p4 >= 2200 && p4 <= 2204) return { brand: 'MIR', color: '#0F754E' };
  if (n[0] === '4') return { brand: 'VISA', color: '#1A1F71' };
  const p2 = parseInt(n.slice(0, 2), 10);
  if ((p2 >= 51 && p2 <= 55) || (p4 >= 2221 && p4 <= 2720)) return { brand: 'Mastercard', color: '#EB001B' };
  return null;
}
